var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as actions from 'app/actions/driver';
import http from 'app/services/http';
const initialState = {
    items: [],
    searchValue: '',
    selectedItem: null,
};
export const driverReducer = (state = initialState, action) => {
    var _a, _b, _c, _d, _e, _f, _g;
    switch (action.type) {
        case 'DRIVER_SET_ITEMS': {
            const { items } = (_a = action.payload) !== null && _a !== void 0 ? _a : {};
            return Object.assign(Object.assign({}, state), { items: items !== null && items !== void 0 ? items : state.items });
        }
        case 'DRIVER_SET_SELECTED_ITEM': {
            const { data } = (_b = action.payload) !== null && _b !== void 0 ? _b : {};
            return Object.assign(Object.assign({}, state), { selectedItem: (_c = data) !== null && _c !== void 0 ? _c : null });
        }
        case 'DRIVER_SET_SEARCH_VALUE': {
            const { value } = (_d = action.payload) !== null && _d !== void 0 ? _d : {};
            return Object.assign(Object.assign({}, state), { searchValue: value !== null && value !== void 0 ? value : '' });
        }
        case 'DRIVER_ADD_ITEM': {
            const data = (_e = action.payload) === null || _e === void 0 ? void 0 : _e.data;
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { items: [...state.items, data] });
        }
        case 'DRIVER_UPDATE_ITEM': {
            const data = (_f = action.payload) === null || _f === void 0 ? void 0 : _f.data;
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { selectedItem: data, items: state.items.map((item) => { var _a; return (item.id !== ((_a = state.selectedItem) === null || _a === void 0 ? void 0 : _a.id) ? item : data); }) });
        }
        case 'DRIVER_DELETE_ITEM': {
            const { id } = (_g = action.payload) !== null && _g !== void 0 ? _g : {};
            return Object.assign(Object.assign({}, state), { items: state.items.filter((item) => item.id !== id), selectedItem: null });
        }
        default:
            return state;
    }
};
export function driverLoad() {
    return function driverLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/driver');
            return dispatch(actions.setItems(data));
        });
    };
}
export function driverCreate(params) {
    return function driverCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post('/driver', params);
            return dispatch(actions.addItem(data));
        });
    };
}
export function driverUpdate(id, updateData) {
    return function driverUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/driver/${id}`, updateData);
            return dispatch(actions.updateItem(data));
        });
    };
}
export function driverDelete(id) {
    return function driverDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.delete(`/driver/${id}`);
            return dispatch(actions.deleteItem(id));
        });
    };
}
export default driverReducer;
